import api from './Api';
import { adminPasswordConfig } from './AdminConfirmation';
export const submitFeedback = (message, roomId) => api.post('/api/feedback', { message }, roomId ? { _roomId: roomId } : undefined);
export const getFeedback = (page = 1, status = '') => api.get('/api/feedback', { params: { page, ...(status ? {status} : {}) } }).then(response => response.data);
export const updateFeedbackStatus = (id, status, password) => api.patch(`/api/feedback/${id}/status`, {status}, adminPasswordConfig(password));
